/**
 * Convercus BI Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChartSeriesSchema { 
    /**
     * Column name from the query result to render as this Y-axis series.
     */
    column: string;
    /**
     * Visual series type for this column.
     */
    type: ChartSeriesSchema.TypeEnum;
    /**
     * Y-axis index for this series; use 0 for the primary axis.
     */
    yAxisIndex: number;
    /**
     * Stack group name; series sharing the same non-empty stack value are stacked together.
     */
    stack?: string;
    /**
     * Localized series/legend label keyed by locale (falls back to the column name when absent). When present must include en and de.
     */
    label?: object;
}
export namespace ChartSeriesSchema {
    export const TypeEnum = {
        Bar: 'bar',
        Line: 'line'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


